import * as React from 'react';
import { createMediaMatcher } from 'react-media-match';

import { Diff } from 'utility-types';

import { MediaQueries } from './theme-config';

export type InjectedMediaProps = {
    media: Record<keyof typeof MediaQueries, boolean>;
    matchMedia: <T extends Partial<Record<keyof typeof MediaQueries, any>>>(
        matchers: T
    ) => T[keyof T];
};

export const {
    Provider: MediaProvider,
    Matches,
    useMedia,
} = createMediaMatcher({
    ...MediaQueries,
});

/**
 * @example
 * ```
 * // default media value: Record<"mobile" | "tablet" | "laptop" | "desktop", boolean>
 *
 * const display = media.mobile ? 'flex' : 'none';
 *
 * const flexDirection = this.props.matchMedia({
 *     mobile: 'column',
 *     tablet: 'row',
 * })
 * ```
 */
function withMedia<P extends InjectedMediaProps>(
    Component: React.ComponentType<P>
): React.FC<Diff<P, InjectedMediaProps>> {
    return (props) => (
        <Matches>
            {(media: InjectedMediaProps['media'], matchMedia: InjectedMediaProps['matchMedia']) => (
                <Component media={media} matchMedia={matchMedia} {...props} />
            )}
        </Matches>
    );
}

export default withMedia;
